//Datadog
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs'
//
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import './scss/App.scss';

import { datadogOptions } from './js/auth';
import './js/polyfills';

import store from './js/store';
import * as serviceWorker from './js/serviceWorker';

import App from './views/App';

import packageJSON from '../package.json';

if (!process.env.REACT_APP_OFFLINE) {
  datadogRum.init({ ...datadogOptions, version: `${packageJSON.version}@${(process.env.COMMIT_HASH ? process.env.COMMIT_HASH : 'undefined')}` });
  datadogLogs.init({ ...datadogOptions, trackSessionAcrossSubdomains: true, forwardConsoleLogs: "all", forwardReports: "all", version: `${packageJSON.version}@${process.env.COMMIT_HASH}` });
  datadogRum.startSessionReplayRecording();
}

const WrappedApp =
  <Provider store={ store }>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>;

ReactDOM.render(WrappedApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
